import {adminUploadFormComponents} from '@modifi/plugin-documents'
import {useTranslation} from '@modifi/plugin-i18n'
import {Col, Row} from '@modifi/ui'
import * as PropTypes from 'prop-types'
import React from 'react'
import {SmallBlock} from './styles'

const DocumentTypeRowWithDescription = React.forwardRef(({documentType, ...restProps}, ref) => {
  const {t} = useTranslation('shared')
  return (
    <>
      <adminUploadFormComponents.DocumentTypeRow
        ref={ref}
        documentType={documentType}
        {...restProps}
      />
      <Row>
        <Col col={12} mb={8} mt={8}>
          <SmallBlock ml={15}>{t(`document-type.description.custom.${documentType}`)}</SmallBlock>
        </Col>
      </Row>
    </>
  )
})

DocumentTypeRowWithDescription.propTypes = {
  documentType: PropTypes.string.isRequired,
}

export default DocumentTypeRowWithDescription
